import Parallax from 'parallax-js';

if (window.innerWidth > 820) {
    var scene = document.getElementById('scene');
    var parallax = new Parallax(scene);
}